import { sortingToteIdFormat } from "@redotech/redo-ids/ids";
import * as z from "zod";

export const deleteSortingTotes = {
  name: "deleteSortingTotes" as const,
  input: z.object({ ids: z.array(sortingToteIdFormat.schema).min(1) }),
  output: z.object({
    success: z.boolean(),
    totesWithInventory: z
      .array(z.object({ toteName: z.string(), totalQuantity: z.number() }))
      .optional(),
  }),
};
